module.exports = __webpack_public_path__ + "static/media/group.e3b4f418.svg";